export default "/images/faxBlack.svg?60208960639728de3138bff05f1138cd";